<template>
  <div class="team-members">
    <TeamMember
      v-for="member in members"
      :key="member.id" :member="member"
    />
  </div>
</template>

<script>
import TeamMember from './TeamMember.vue';

export default {
  data() {
    return {
      members: [
        { 
          id: 1,
          city: 'Madrid',
          image: 'https://clubejecutivo.s3.us-east-2.amazonaws.com/assets/images/team/Jose-Manuel-Cosio.png',
          name: 'Jose Manuel Cosío',
          position: 'Responsable de Desarrollo de negocio. Madrid Juan Bravo',
        },
        {
          id: 3,
          city: 'Bilbao',
          image: 'https://clubejecutivo.s3.us-east-2.amazonaws.com/assets/images/team/Elena-Zalbide-Elorduy.png',
          name: 'Elena Zalbide Elorduy',
          position: 'Responsable de Desarrollo de negocio. Alicante',
        },
        {
          id: 4,
          city: 'La Rioja',
          image: 'https://clubejecutivo.s3.us-east-2.amazonaws.com/assets/images/team/Roberto-Ruiz-Yecora.png',
          name: 'Roberto Ruiz Yécora',
          position: 'Responsable de Desarrollo de negocio. La Rioja',
        },
        {
          id: 5,
          city: 'Castellón',
          image: 'https://clubejecutivo.s3.us-east-2.amazonaws.com/assets/images/team/Carolina-Salvador-Moliner.png',
          name: 'Carolina Salvador Moliner',
          position: 'Responsable de Desarrollo de negocio. Castellón',
        },
      ]
    }
  },
  components: {
    TeamMember
  }
}
</script>

<style>
  .team-members {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
</style>